<template>
	<!-- Always in flow: .app-shell gives it the leftover space, so it sits at the bottom of a
	     short page and after the content of a long one. isFooterFixed used to add
	     position: fixed here, which laid the footer over the end of every long page. -->
	<footer v-show="isFooterBarVisible" class="footer">
		<div class="footer-brand">
			<a :href="$lang.Menus.SiteUrl" target="_blank" rel="noopener" class="footer-logo">
				<img src="/img/eae-elektroteknik-logo.png" alt="EAE Elektroteknik" />
			</a>
			<span class="footer-copyright">{{ $lang.Menus.FooterA }}<a :href="$lang.Menus.SiteUrl" target="_blank" rel="noopener">{{ $lang.Menus.FooterBrand }}</a>{{ $lang.Menus.FooterB }} &copy; {{ year }} {{ $lang.Menus.FooterRights }}</span>
		</div>
		<div class="footer-social">
			<a v-for="s in socials"
			   :key="s.name"
			   :href="s.href"
			   :aria-label="s.name"
			   target="_blank"
			   rel="noopener">
				<span :class="['mdi', s.icon]" aria-hidden="true"></span>
			</a>
		</div>
	</footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'FooterBar',
	data() {
		return {
			year: new Date().getFullYear(),
			// The same accounts EAE's own site links to.
			socials: [
				{ name: 'LinkedIn', icon: 'mdi-linkedin', href: 'https://www.linkedin.com/company/eaeelektroteknik' },
				{ name: 'Facebook', icon: 'mdi-facebook', href: 'https://www.facebook.com/eaeelektroteknik' },
				{ name: 'Instagram', icon: 'mdi-instagram', href: 'https://www.instagram.com/eaeelektroteknik' },
				{ name: 'YouTube', icon: 'mdi-youtube', href: 'https://www.youtube.com/@eae.elektroteknik' }
			]
		};
	},
	computed: {
		...mapState(['isFooterBarVisible'])
	}
};
</script>
